export default __webpack_public_path__ + "media/images/features/yado/title_sp-ecbf45567f5fc722c87061a3aa93257f.jpg";